module.exports = __webpack_public_path__ + "static/media/ab10.61d4c4c7.png";